import React from 'react';
import { Modal } from '../../components/ui';
import { isWeddingFunction, MAX_NAME } from '../../utils/helpers';

// Mobile "Quick add": full-screen list of compact guest lines — names and
// number on top, the functions as tap chips underneath. All logic is in useQuickAdd.
export default function QuickAddMobile({ vm }) {
  const {
    quickRows, quickFunctions, quickSaving, quickProgress, filledCount, closeQuick, quickVisibility, setQuickVisibility,
    setQuickField, toggleQuickFunction, addQuickRows, removeQuickRow, saveQuick,
  } = vm.quick;

  return (
    <Modal fullScreen className="gx-m-quick" title="Quick add guests" onClose={closeQuick}
      footer={(
        <>
          <button type="button" className="btn light" style={{ padding: 12 }} onClick={() => addQuickRows(1)} disabled={quickSaving}>+ Line</button>
          <button type="button" className="btn primary" style={{ flex: 2, padding: 12 }} onClick={saveQuick} disabled={quickSaving || !filledCount}>
            {quickSaving ? `Saving ${quickProgress.done}/${quickProgress.total}…` : `Save ${filledCount || ''}`}
          </button>
        </>
      )}>
      <div className="muted" style={{ fontSize: 12, marginBottom: 8 }}>
        New lines copy the functions above. Ticking any function also ticks the Wedding.
      </div>
      {/* The whole batch is Private unless it is made Public here. */}
      <div className="gx-m-label">Who can see these guests</div>
      <div className="gx-m-seg" style={{ marginBottom: 10 }}>
        {['Private', 'Common'].map(v => (
          <button key={v} type="button" className={quickVisibility === v ? 'on' : ''} disabled={quickSaving}
            onClick={() => setQuickVisibility(v)}>
            {v === 'Private' ? '🔒 Only me + admin' : '👁 All members'}
          </button>
        ))}
      </div>
      <div className="quick-add-cards">
        {quickRows.map((r, i) => (
          <div key={r.key} className={'quick-add-card' + (r.error ? ' has-error' : '')}>
            <div className="quick-add-line">
              <span className="muted">{i + 1}</span>
              <input placeholder="Surname" value={r.Surname} maxLength={MAX_NAME} disabled={quickSaving}
                onChange={e => setQuickField(r.key, 'Surname', e.target.value)} />
              <input placeholder="Name *" value={r.GuestName} maxLength={MAX_NAME} disabled={quickSaving}
                onChange={e => setQuickField(r.key, 'GuestName', e.target.value)} />
              <button type="button" className="icon-btn danger" disabled={quickSaving || quickRows.length === 1}
                onClick={() => removeQuickRow(r.key)}>✕</button>
            </div>
            <input className="quick-add-mobile" type="tel" inputMode="numeric" placeholder="Mobile (optional)"
              value={r.MobileNumber} disabled={quickSaving}
              onChange={e => setQuickField(r.key, 'MobileNumber', e.target.value)} />
            <div className="gx-m-fns tight grid2" style={{ marginBottom: 0 }}>
              {quickFunctions.map(f => {
                const on = r.FunctionIds.includes(String(f.FunctionId));
                return (
                  <button key={f.FunctionId} type="button" disabled={quickSaving}
                    className={'cg-m-fn' + (on ? ' on' : '')} onClick={() => toggleQuickFunction(r.key, f.FunctionId)}>
                    <span className="cg-m-check">{on ? '✓' : ''}</span>
                    <span className="cg-fn-name">{isWeddingFunction(f) ? '💍 ' : ''}{f.FunctionName}<span className="fn-count">({vm.fnCount(f.FunctionId)})</span></span>
                  </button>
                );
              })}
            </div>
            {r.error && <div className="quick-add-error-text">⚠ {r.error}</div>}
          </div>
        ))}
      </div>
    </Modal>
  );
}
